module.exports = __webpack_public_path__ + "media/images/arrow-left-black-e704f916891498c2819b6df1c65b9b95.svg";